<template>
  <section class="lms-container">
    <div class="content">
      <div class="breadcrumb" style="border: none !important;"></div>

      <div
        style="position:relative;margin:0;padding-bottom:56.25%;padding-top:35px;height:0;overflow:hidden;"
      >
        <iframe
          src="https://iapa.eadmeeting.com/Transmissao-ao-vivo"
          width="100%"
          height="100%"
          frameborder="0"
          scrolling="auto"
          allowfullscreen
          style="position:absolute;margin:0;padding:0;top:0;left:0;width:100%;height:100%;"
        ></iframe>
      </div>
    </div>
  </section>
</template>


<script>
import axios from "axios";

export default {
  data() {
    return {
    };
  },
  components: {},
  methods: {},
  created() {}
};
</script>
